<template>
  <PageLayoutWrapper page="departments/index">
    <h1 class="text-3xl font-normal mb-4">Departments</h1>
    <RichContent
      class="main-content"
      :content="pageContent"
    />
    <DepartmentsList data-test="dept-list" />
  </PageLayoutWrapper>
</template>

<script>
import DepartmentsList from '@/components/PrebuiltContent/DepartmentsList'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import pageLayout from '@/mixins/pageLayoutMixin'
import RichContent from '@/components/RichContent'
import { metaTags, metaTitle } from '@/utils/meta'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { HIDE_DEPARTMENTS } from '@/constants/featureFlags'
import useMeta from '@/composables/useMeta'

export default {
  setup() {
    const { hideDepartments } = useFeatureFlags({
      hideDepartments: HIDE_DEPARTMENTS,
    })
    const { catalogWideMetaTitle } = useMeta()
    return {
      hideDepartments,
      catalogWideMetaTitle,
    }
  },
  components: { DepartmentsList, PageLayoutWrapper, RichContent },
  mixins: [pageLayout],
  computed: {
    pageContent() {
      return this.$route.query.preview
        ? this.page.temporaryContent
        : this.page.content
    },
  },
  async asyncData({ $axios, $bugsnag, redirect, store }) {
    const url = `/ca/${store.state.settings.school}/catalogPages/${
      store.state.settings.activeCatalog
    }/departments`
    try {
      const page = await $axios.$get(url)
      return {
        page,
      }
    } catch (e) {
      $bugsnag.notify(e)
      redirect('/404')
    }
  },
  head() {
    return {
      ...metaTitle(this.page?.metafields, this.catalogWideMetaTitle),
      meta: [
        ...(this.hideDepartments
          ? [{ hid: 'robots', name: 'robots', content: 'noindex' }]
          : []),
        ...metaTags(this.page?.metafields),
      ],
    }
  },
}
</script>

<style lang="css" scoped>
</style>
